import request from './axios'

export function getHomeInfo(num,index) {
  return request({
    url: '/api/v1/overviews/data?days='+num+'&index='+index,
    method: 'get'
  })
}

export function getHomeIndex() {
  return request({
    url: '/api/v1/overviews/index',
    method: 'get'
  })
}

export function getDataTrends(name,index) {
  return request({
    url: '/api/v1/trends/data?name='+name+'&index='+index,
    method: 'get'
  })
}

export function getNames(index) {
  return request({
    url: '/api/v1/trends/names?index='+index,
    method: 'get'
  })
}

export function getProxiesNodes(page,pagesize,order_by,order) {
  return request({
    url: '/api/v1/proxies/nodes?page='+page+'&pagesize='+pagesize+'&order_by='+order_by+'&order='+order,
    method: 'get'
  })
}

export function getStatusData(page,pagesize,order_by,order,index) {
  return request({
    url: '/api/v1/status/data?page='+page+'&pagesize='+pagesize+'&order_by='+order_by+'&order='+order+'&index='+index,
    method: 'get'
  })
}

export function getVenuesIndex() {
  return request({
    url: '/api/v1/venues/index',
    method: 'get'
  })
}

export function getVenuesList(index) {
  return request({
    url: '/api/v1/venues/list?paper_index='+index,
    method: 'get'
  })
}

export function getVenuesData(index,name) {
  return request({
    url: '/api/v1/venues/data?paper_index='+index+'&origin_name='+name,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js